module.exports = "<input type=\"text\" id=\"inputtext\"  [ngModel]=\"texte\" (ngModelChange)=\"OnChange($event)\"  cols=\"30\" placeholder=\"Votre réponse\">\n"